import * as React from 'react';
import * as moment from 'moment';

interface Props {
  company: any;
}

export default ({ company }: Props) => (
  <table>
    <tbody>
      <tr>
        <th>Name</th>
        <td>{company.name}</td>
      </tr>
      <tr>
        <th>Address</th>
        <td>
          {company.address}
          {!!company.address_2 ? (
            <span>
              <br />
              {company.address_2}
            </span>
          ) : null}
          <br />
          {company.city}
          <br />
          {company.county}
          <br />
          {company.postcode}
        </td>
      </tr>
      <tr>
        <th>Phone number</th>
        <td>{company.phone_number}</td>
      </tr>
      <tr>
        <th>General Contact</th>
        <td>
          {company.general_contact_name}
          <br />
          {company.general_contact_email}
        </td>
      </tr>
      <tr>
        <th>Accounts Contact</th>
        <td>
          {company.accounts_contact_name}
          <br />
          {company.accounts_contact_email}
        </td>
      </tr>
      <tr>
        <th>Pays Own Insurance?</th>
        <td>{company.pay_own_insurance ? 'Yes' : 'No'}</td>
      </tr>
      <tr>
        <th>Insurance</th>
        <td>
          {company.insurer}
          <br />
          {company.policy_number}
        </td>
      </tr>
      <tr>
        <th>Insurance Expiry</th>
        <td>
          {company.expiry_date
            ? moment(company.expiry_date).format('DD.MM.YYYY')
            : ''}
        </td>
      </tr>
      <tr>
        <th>Has Account?</th>
        <td>{company.has_account ? 'Yes' : 'No'}</td>
      </tr>
      <tr>
        <th>Account Type</th>
        <td>{company.account_type}</td>
      </tr>
      <tr>
        <th>Account Card Expiry</th>
        <td>
          {company.account_card_expiry
            ? moment(company.account_card_expiry).format('DD.MM.YYYY')
            : ''}
        </td>
      </tr>
      <tr>
        <th>Online Bypass</th>
        <td>
          {company.has_account && company.account_online_bypass ? 'Yes' : 'No'}
        </td>
      </tr>
    </tbody>
  </table>
);
